import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    navigate('/');
  };


  return (
    <header className="bg-light shadow-sm">
      <div className="container d-flex align-items-center py-3">
        <div className="d-flex align-items-center" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center text-white fw-bold" style={{ width: '40px', height: '40px', fontSize: '20px' }}>
            B
          </div>
          <span className="ms-2 fs-4 fw-light text-muted">beauty wholesale club</span>
        </div>
        {location.pathname !== '/' && (
          <div className="ms-auto">
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
